import axios, { baseUrl } from './axios';
import { get } from 'lodash';
import queryString from 'query-string';

export default {
  getBookingSlots: async options => {
    const result = await axios.post(
      `${baseUrl}/scheduler/pob/booking_slots`,
      options.data,
    );

    return result.data;
  },
  getNextAvailableBookingSlots: async options => {
    const result = await axios.post(
      `${baseUrl}/scheduler/pob/next_available`,
      options.data,
    );

    return result.data;
  },
  holdBookingSlot: async data => {
    const result = await axios.post(
      `${baseUrl}/scheduler/pob/holdcalendars`,
      data,
    );
    return result.data;
  },
  releaseBookingSlot: async options => {
    const params = queryString.stringify(options.filter);
    const result = await axios.delete(
      `${baseUrl}/scheduler/pob/holdcalendars/${options.uuid}${
        params ? `?${params}` : ''
      }`,
    );
    return result.data;
  },

  createBooking: async options => {
    const token = get(options, 'token');

    let transformRequest = {};
    if (token) {
      transformRequest = {
        transformRequest: [
          (data, headers) => {
            headers.common.Authorization = `Bearer ${options.token}`;
            return JSON.stringify(data);
          },
        ],
      };
    }
    const result = await axios.post(
      `${baseUrl}/scheduler/pob/booking`,
      options.data,
      {},
      transformRequest,
    );
    return result.data;
  },
};
